<template>
  <div>
    <div class="text-center" v-if="running">
      <span v-if="days">{{ isNegative ? '-' : '' }}{{ days }}:</span>
      <span v-if="hours">{{ isNegative && !days ? '-' : '' }}{{ formatTime(hours) }}:</span>
      <span style="font-weight: normal; font-size: 14px;">
        <span v-if="!hours && !days && isNegative">-</span>{{ formatTime(minutes) }}:{{ formatTime(seconds) }}
      </span>
    </div>
    <div class="text-center" style="font-weight: normal; font-size: 14px;" v-else>
      <span>00:00</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CountdownTimer",
  props: {
    // 'YYYY/MM/DD HH:mm:ss' (albo ISO). Wymagane.
    deadline: { type: String, required: true },
    // ms
    speed: { type: Number, default: 1000 },
    objNumber: { type: String },
    visible: { type: Boolean, default: true },
    // Dodatkowy czas po deadlinie — ms (np. preferences.checkpointAdditionalTime * 1000)
    serverDiff: { type: Number, default: 0 },
  },
  data() {
    return {
      timerId: null,
      deadlineTs: 0,  // ms
      endTs: 0,       // ms (deadline + serverDiff)
      displayMs: 0,   // ms do wyświetlenia (zawsze dodatnie)
      isNegative: false,
      running: true,
    };
  },
  mounted() {
    this.recomputeTs();
    this.tick(); // start
  },
  beforeUnmount() {
    if (this.timerId) clearTimeout(this.timerId);
  },
  watch: {
    deadline() { this.recomputeTs(true); },
    serverDiff() { this.recomputeTs(true); },
  },
  computed: {
    seconds() { return Math.floor((this.displayMs / 1000) % 60); },
    minutes() { return Math.floor((this.displayMs / 1000 / 60) % 60); },
    hours()   { return Math.floor((this.displayMs / (1000 * 60 * 60)) % 24); },
    days()    { return Math.floor(this.displayMs / (1000 * 60 * 60 * 24)); },
  },
  methods: {
    // Bezpieczne parsowanie  'YYYY/MM/DD HH:mm:ss' -> ISO 'YYYY-MM-DDTHH:mm:ss'
    parseDeadlineToMs(str) {
      if (!str) return Date.now();
      const isoish = str.replace(/\//g, "-").replace(" ", "T");
      const ts = Date.parse(isoish);
      return Number.isNaN(ts) ? Date.now() : ts;
    },

    recomputeTs(restart = false) {
      const sd = Math.max(0, Number(this.serverDiff || 0)); // ms
      this.deadlineTs = this.parseDeadlineToMs(this.deadline);
      this.endTs = this.deadlineTs + sd;
      if (restart) {
        if (this.timerId) clearTimeout(this.timerId);
        this.running = true;
        this.tick();
      }
    },

    tick() {
      const now = Date.now();

      if (now < this.deadlineTs) {
        // Faza 1: do deadlinu
        this.isNegative = false;
        this.displayMs = this.deadlineTs - now;
        this.timerId = setTimeout(this.tick, this.speed);
        return;
      }

      if (now < this.endTs) {
        // Faza 2: „na minusie” — liczymy jeszcze serverDiff,
        // ale pokazujemy znak minus przed czasem
        this.isNegative = true;
        this.displayMs = this.endTs - now; // ile zostało z dodatkowego okna
        this.timerId = setTimeout(this.tick, this.speed);
        return;
      }

      // Koniec: deadline + serverDiff
      this.isNegative = false;
      this.displayMs = 0;
      this.running = false;
      if (this.objNumber) {
        this.$emit("endCountdown", { id: this.objNumber });
      }
    },

    formatTime(value) {
      return value < 10 ? "0" + value : String(value);
    },
  },
};
</script>
